import { SchemaColumn } from "types/SchemaTypes"


export function uniqueFieldsFromSchema (schema: Array<SchemaColumn>): string[] {
    return schema.filter(col => col.unique_group === true).map(col => col.name)
}
